// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"427":"2ab9b30187b46bc226b0","674":"36916e962910faa7737d","872":"03e967932369f5f61719"}[chunkId] + ".js";
};